import React from "react";
import { useLocation } from "react-router-dom";
import { Container } from "components/misc/Layouts";
import tw from "twin.macro";

import { SectionHeading } from "components/misc/Headings";
import usePageMeta from "blog/utils/usePageMeta.js";

const HeadingRow = tw.div`flex justify-center`; // Centre le texte horizontalement
const Heading = tw(SectionHeading)`text-xl sm:text-2xl font-black tracking-wide text-center`;

/**
 * Écran générique servant à la fois de page 404 (route « * ») et de page « en construction »
 * pour les pages légales pas encore rédigées (/rgpd, /politique, /conditions, /avertissement).
 *
 * Dans les deux cas la page n'a pas de contenu à indexer : usePageMeta pose un titre, une
 * description et un canonique propres, avec `noindex` (les moteurs peuvent suivre les liens,
 * mais n'ajoutent pas ces URL à leur index).
 */

// Libellés des pages légales en construction, par chemin.
const PAGES_EN_CONSTRUCTION = {
  "/rgpd": "Données personnelles (RGPD)",
  "/politique": "Politique de confidentialité",
  "/conditions": "Conditions d'utilisation",
  "/avertissement": "Avertissement",
};

export default ({ headingText = "! Page en construction !" }) => {
  const { pathname } = useLocation();
  const label = PAGES_EN_CONSTRUCTION[pathname];

  usePageMeta({
    title: label ? `${label} — page en construction` : "Page introuvable",
    description: label
      ? `La page « ${label} » d'IA Besançon est en cours de rédaction. Elle sera publiée prochainement.`
      : "Cette page n'existe pas ou a été déplacée. Retrouvez les articles d'IA Besançon depuis le blog.",
    path: pathname,
    noindex: true,
  });

  return (
    <Container>
      <HeadingRow>
        <Heading><br/><br/><br/><br/>{headingText}</Heading>
      </HeadingRow>
    </Container>
  );
};
